/**
 * Account area text constants
 */

export const DROPDOWN = {
  ACCOUNT_SETTINGS: "Account Settings",
  LOGOUT: "Logout",
} as const;

export const TABS = {
  PROFILE: "Profile",
  SUBSCRIPTION: "Subscription",
  USAGE: "Usage",
  AUTO: "Auto",
} as const;

export const MODAL = {
  TITLE: "Account Settings",
  CLOSE_ARIA_LABEL: "Close account settings",
} as const;

export const PLACEHOLDERS = {
  PROFILE_TAB: "Profile settings coming soon",
  SUBSCRIPTION_TAB: "Subscription details coming soon",
  STATISTICS_TAB: "Usage statistics coming soon",
} as const;

export const PROFILE_TAB = {
  SECTION_TITLE: "Profile Information",
  EDIT_BUTTON: "Edit",
  USER_NAME_LABEL: "User Name",
  EMAIL_LABEL: "Email",
  EMPTY_PLACEHOLDER: "—",
  LOADING_ERROR: "Failed to load profile data.",
} as const;

export const EDIT_PROFILE_MODAL = {
  TITLE: "Edit Profile",
  INPUT_LABEL: "User name",
  INPUT_PLACEHOLDER: "Enter your name",
  CANCEL: "Cancel",
  SAVE: "Save",
  CLOSE_ARIA_LABEL: "Close edit profile",
} as const;

export const EDIT_PROFILE_VALIDATION = {
  REQUIRED: "User name can't be empty",
  INVALID_CHARS: "User name can only contain letters and spaces",
  TOO_LONG: "User name must be 50 characters or fewer",
} as const;

export const EDIT_PROFILE_API_ERROR =
  "Failed to save profile. Please try again." as const;

export const SUBSCRIPTION_TAB = {
  SECTION_TITLE: "Current Plan",
  FALLBACK_PLAN: "Free",
  // Paid plans are live (Stripe): the free plan's line points at them, a paid plan's says thanks.
  DESCRIPTION_FREE: "Your first hour of video is free. Subscribe for more hours every month.",
  DESCRIPTION_PAID: "Thanks for subscribing. Your hours renew every month.",
  LOADING_ERROR: "Failed to load subscription data.",
  // The way to change plan from here — Cancel used to be reachable only by typing the URL.
  MANAGE_BUTTON: "Manage or cancel plan",
  PLANS_BUTTON: "See plans",
} as const;

export const USAGE_TAB = {
  SECTION_TITLE: "Usage Limits",
  STORAGE_LABEL: "Storage used",
  TRANSCRIPTION_LABEL: "Transcription hours",
  EXPORTS_LABEL: "Exports / monthly",
  LOADING_ERROR: "Failed to load usage data.",
} as const;

export const AUTO_TAB = {
  SECTION_TITLE: "Auto — send finished videos out",
  DESCRIPTION:
    "Paste the webhook URL from your make.com scenario. Every video you export is sent there automatically with its link, its details and a suggested caption — so it can land as a draft, ready for you to add music and post.",
  INPUT_LABEL: "make.com webhook URL",
  INPUT_PLACEHOLDER: "https://hook.eu2.make.com/…",
  ENABLED_LABEL: "Send my exports automatically",
  SAVE: "Save",
  SAVING: "Saving…",
  TEST: "Send test",
  TESTING: "Sending…",
  DISCONNECT: "Disconnect",
  SAVED: "Saved.",
  TEST_SENT: "Test packet delivered — check your make.com scenario.",
  TEST_NEEDS_SAVE: "Save the webhook URL first, then send a test.",
  LOADING_ERROR: "Failed to load your Auto settings.",
  SAVE_ERROR: "Couldn't save that webhook URL.",
  NEVER_FIRED: "Nothing sent yet.",
  LAST_OK: "Last sent",
  LAST_FAILED: "Last attempt failed",
  // Post mode: when a finished video goes out, and how it is posted.
  WHEN_LABEL: "When a video finishes",
  WHEN_NOW: "Send it right away",
  WHEN_REVIEW: "Wait for me to press Post",
  WHEN_REVIEW_HINT: "Finished videos wait in My Library → Exported, each with a 📤 Post button.",
  PRIVACY_LABEL: "Post it as",
  PRIVACY_PRIVATE: "Private",
  PRIVACY_PUBLIC: "Public",
  PUBLIC_HINT:
    "For Public to work, your make.com YouTube step has to read it: open that step, click Privacy, and pick post → privacy.",
  DRAFT_NOTE:
    "Private videos are sent as drafts. Trending sounds can only be added inside each app, and they are what drives reach.",
} as const;
